/* cart-offers.js
 * Keplin: applying an offer from the Discounts panel.
 *
 * WHY THIS EXISTS instead of <form is="cart-discount">:
 * CartDiscount in cart.js always APPENDS the new code to the codes already on
 * the cart and posts the whole list. Shopify rejects the request when those
 * codes are not combinable, which is the "The discount code cannot be applied
 * to your cart" error you hit switching between MICRO15 and WELCOME10.
 *
 * BEHAVIOUR:
 *   1. try the new code alongside what is already applied, so genuinely
 *      combinable discounts still stack
 *   2. if Shopify reports the new code as not applicable, retry with that code
 *      on its own, which swaps the old one out
 *   3. only if that also fails do we surface an error
 *
 * Everything else mirrors CartDiscount exactly: same endpoint, same section
 * bundling, same pubsub republish, so the drawer re-renders identically.
 */
(function () {
  function bundledSections() {
    var list = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: list } })
    );
    return list;
  }

  // Same source of truth cart.js uses, so the two never disagree.
  function appliedCodes() {
    var out = [];
    var list = document.querySelector('.cart__discounts');
    if (!list) return out;
    var items = list.querySelectorAll('.discount');
    for (var i = 0; i < items.length; i++) {
      var code = items[i].getAttribute('data-discount-code');
      if (code) out.push(code);
    }
    return out;
  }

  function post(codes) {
    var config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var body = new FormData();
    body.append('sections', bundledSections());
    body.append('sections_url', window.location.pathname);
    body.append('discount', codes.join(','));
    config.body = body;

    return fetch(FoxTheme.routes.cart_update_url, config).then(function (res) {
      return res.json();
    });
  }

  function rejected(state, code) {
    if (!state || !state.discount_codes) return false;
    var wanted = String(code).toLowerCase();
    for (var i = 0; i < state.discount_codes.length; i++) {
      var d = state.discount_codes[i];
      if (String(d.code).toLowerCase() === wanted && d.applicable === false) return true;
    }
    return false;
  }

  function republish(state) {
    return fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig())
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cart.sections = state.sections;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      });
  }

  function message(scope, text) {
    var box = scope ? scope.querySelector('[data-kp-msg]') : null;
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
  }

  function busy(btn, on) {
    btn.classList.toggle('btn--loading', !!on);
    if (on) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
  }

  // Close the sheet before republishing, so ModalComponent can undo its scroll
  // lock while its element still exists. The re-render then rebuilds it hidden.
  function closeSheet(btn) {
    var sheet = btn.closest('.cart-addons-drawer');
    if (sheet && typeof sheet.hide === 'function') sheet.hide();
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var btn = event.target.closest('[data-kp-apply]');
    if (!btn) return;

    event.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    if (typeof FoxTheme === 'undefined') return;

    var scope = btn.closest('[data-kp-offer]') || btn.parentElement;

    message(scope, '');

    // Remove every code from the cart.
    if (btn.hasAttribute('data-kp-clear')) {
      busy(btn, true);
      post([])
        .then(function (state) {
          closeSheet(btn);
          return republish(state);
        })
        .catch(function (e) { console.error(e); })
        .then(function () { busy(btn, false); });
      return;
    }

    var code = (btn.getAttribute('data-kp-code') || '').trim();

    if (btn.hasAttribute('data-kp-from-input')) {
      var input = scope.querySelector('input[name="discount"]');
      code = input ? input.value.trim() : '';
      if (!code) {
        message(scope, 'Enter a code first.');
        return;
      }
    }

    if (!code) return;

    var existing = appliedCodes().filter(function (c) {
      return String(c).toLowerCase() !== code.toLowerCase();
    });

    busy(btn, true);

    post(existing.concat([code]))
      .then(function (state) {
        // Not combinable with what is on the cart. Swap rather than fail.
        if (rejected(state, code)) return post([code]);
        return state;
      })
      .then(function (state) {
        if (rejected(state, code)) {
          message(scope, 'This code cannot be used with your current basket.');
          return;
        }
        closeSheet(btn);
        return republish(state);
      })
      .catch(function (e) { console.error(e); })
      .then(function () { busy(btn, false); });
  });

  // Enter key in the manual code field.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-kp-form]')) return;
    event.preventDefault();
    var btn = form.querySelector('[data-kp-apply]');
    if (btn) btn.click();
  });
})();